import React, { useEffect, useState } from 'react'
import CustomersTable from '../../../tabels/CustomersTable'
import { badgeList } from '../../../../functions/stateList'
import CustomerCarsModal from '../../../modal/CustomerCarsModal'

function CustomerList({
  search_value,
  customersType,
  openTab,
  setOpenTab,
  customerTypeListItem,
  customers,
}) {
  const [showModal, setShowModal] = useState(false)
  const [customer, setCustomer] = useState(null)
  const [users, setUsers] = useState([])
  const [customersTypeList, setCustomerTypeList] = useState([])

  const editCustomer = (customer) => {
    setShowModal(true)
    setCustomer(customer)
  }

  useEffect(() => {
    setCustomerTypeList([{ id: 0, value: 'همه', color: '#03fcdf' }, ...customersType])
    setUsers(customers)
  }, [customersType])

  useEffect(() => {
    setUsers(
      customers.filter(({ mobile }) => mobile.toLowerCase().includes(search_value.toLowerCase()))
    )
  }, [search_value])

  return (
    <>
      <div className="w-full mt-16">
        <div className="flex md:items-center flex-col md:flex-row mb-8">
          <div className="flex items-center mb-4 md:mb-0">
            <i
              className={
                'icon-document-filter text-black text-2xl dark:text-slate-200 pl-3 md:pl-1 block md:hidden'
              }
            />
            <h2 className="font-medium text-xl pl-4 dark:text-amber-50">لیست کاربران</h2>
          </div>
          <div className="flex items-center">
            <i
              className={
                'icon-document-filter text-black dark:text-slate-200 text-2xl pl-3 md:pl-1 hidden md:block'
              }
            />
            <div
              className={'text-base font-light text-black dark:text-slate-200 pl-8 hidden md:block'}
            >
              مرتبط سازی :
            </div>
            <ul className="flex gap-8 list-none flex-wrap flex-row" role="tabList">
              {customersTypeList &&
                customersTypeList.map((customersType) => (
                  <li key={customersType?.id} className="text-center">
                    <button
                      dir="ltr"
                      className={`text-base block leading-normal 
                                        ${
                                          openTab === customersType?.id
                                            ? 'text-blue dark:text-amber-200 font-medium'
                                            : 'text-inactive-icon'
                                        }`}
                      onClick={() => setOpenTab(customersType?.id)}
                      data-toggle="tab"
                      role="tabList"
                    >
                      <span className={`${badgeList}`}>
                        {customersType?.id !== 0
                          ? customerTypeListItem[customersType?.id]?.length
                          : users.length}
                      </span>
                      {customersType?.value}
                    </button>
                  </li>
                ))}
            </ul>
          </div>
        </div>
        <CustomersTable
          customers={users}
          customerTypeListItem={customerTypeListItem}
          openTab={openTab}
          editCustomer={editCustomer}
        />
      </div>
      {showModal && <CustomerCarsModal customer={customer} setShowModal={setShowModal} />}
    </>
  )
}

export default React.memo(CustomerList)
